<div class="recovery-confirmation">
  <img alt="menu logo" src="{{ LOGO }}" class="img__logo" />
  <div class="title__container">
    <h3 class="main-title">Zaboravljena lozinka</h3>
  </div>
  <p class="text">Proveri svoj email za poruku sa instrukcijama za oporavak naloga</p>
  <div class="button__container">
    <button class="btn--orange">
      <a routerLink="/{{ LOGIN_ROUTE }}" class="btn__text">Prijavi se</a>
    </button>
  </div>
</div>
